import { render } from "./CommentMessage.vue?vue&type=template&id=e2fc496c"
import script from "./CommentMessage.vue?vue&type=script&lang=js"
export * from "./CommentMessage.vue?vue&type=script&lang=js"

import "./CommentMessage.vue?vue&type=style&index=0&id=e2fc496c&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__